<template>
  <div class="card">
    <div class="card-header pb-0">
      <h6>Members</h6>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0" >
        <table class="table table-sm align-items-center mb-0" >
          <thead>
            <tr>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 " >
                Line Display</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >สมาชิก</th>
                <!-- <button @click="sort_line_clicked()">Line Display / UID</button></th> -->
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >ยอดเติม</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >ส่วนแบ่ง</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >Status</th>

              <!-- ><button @click="sort_status_clicked()">Status</button></th> -->
              <th class="text-secondary opacity-7"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in users" :key="user.username">
              <td>
                <div class="d-flex px-2 py-1">
                  <div class="d-flex flex-column justify-content-center">
                    <h6 class="mb-0 text-sm" @click="user_clicked(user)">{{user.line_display}}</h6>
                    <!-- <p class="text-xs text-secondary mb-0">{{user.username.slice(0,15) + " .."}}</p> -->
                  </div>
                </div>
              </td>

              <td class="align-middle text-center">
                <button type="button" class="btn btn-info btn-icon" style="width:50px; text-align:center" 
                @click="user_clicked(user)">
                  {{user.t3.length}} 
                </button>
              </td>
              <td class="align-middle text-center text-sm">
                <span class="text-secondary text-xs font-weight-bold">0.00</span>
              </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">0.00</span>
              </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">-</span>
              </td>

              <!-- <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">{{new Date(user.expire_date).toLocaleDateString('th-TH')  }} ({{user.balance_days}})</span>
              </td> -->

            </tr> 



          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from 'axios'
const qs = require('querystring')
var host_api=window.localStorage.getItem('$host_api');

export default {
  name: "t2-table",
  props:[
    // uid:String,
    // 'members'
  ],
  data() {
    return {
      users : [],
      username : "",
      sort_type : 0
    }
  },
  methods :{ 
    user_clicked (user) {
      console.log(user.t3)
      if (user.t3.length > 0) {
        console.log('go')
        this.$store.state.t3 = user.t3
        this.$store.state.user3 = user
        // this.$store.state.t3over = this.$store.state.user2;
        this.$router.push('/t3');
        // this.users = user.t2
      }
      

    },

    sort_line_clicked (){
      this.sort_type = 0
    },
    sort_status_clicked (){
      this.sort_type = 2
    },

  },
  created() {
    
    this.users = this.$store.state.t2
    console.log(this.users[0])
    this.users.forEach(user => {
      if(user.line_display == null || user.line_display == '' || user.line_display == undefined)
        user.line_display = '[No Display]'
      else if (user.line_display.length > 15)
        user.line_display = user.line_display.slice(0,15);
    });


  }, 
  computed: {
  }
};

</script>
